import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const deleteCta = async (payload) => {
    payload = {
        cta_name_value: payload["cta name"],
        lob_value: payload["lob name"],
        source: payload["source"],
    }
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/delete_cta`,
        data: payload,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}